'use strict';
const DEFAULT_BASE = '/assets/';
/**
 * Resolves URLs for files in mead's `assets/` folder (images, emoji data).
 *
 * By default assets are expected at `/assets/...`, served by the consuming app.
 * Apps that serve them elsewhere can change the base URL, and builds that bundle
 * the files (e.g. the React bundle) can register a resolver instead.
 */
class AssetPathsClass {
    constructor() {
        this.base = DEFAULT_BASE;
        this.resolver = undefined;
    }
    /**
     * Set the base URL assets are served from, e.g. '/static/mead/' or a CDN URL
     * @param base
     */
    setBase(base) {
        this.base = base.endsWith('/') ? base : `${base}/`;
        return this;
    }
    /**
     * Set a resolver that is asked first for every asset path
     * @param resolver
     */
    setResolver(resolver) {
        this.resolver = resolver;
        return this;
    }
    /**
     * Returns the URL for an asset path relative to the assets folder, e.g. 'img/play.svg'
     * @param path
     */
    url(path) {
        const clean = path.replace(/^\/+/, '').replace(/^assets\//, '');
        const resolved = this.resolver ? this.resolver(clean) : undefined;
        return resolved !== undefined ? resolved : `${this.base}${clean}`;
    }
    /**
     * Restore the default base URL and remove any resolver
     */
    reset() {
        this.base = DEFAULT_BASE;
        this.resolver = undefined;
        return this;
    }
}
const AssetPaths = new AssetPathsClass();
export { AssetPaths };
export default AssetPaths;
//# sourceMappingURL=AssetPaths.js.map